import React from 'react';
import LandingPage from './SpaceApp/Home';
import Navbar from './SpaceApp/Navigation';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
import reportWebVitals from './reportWebVitals';
import Destination from './SpaceApp/Destination';
import Crew from './SpaceApp/Crew';
import Technology from './SpaceApp/Technology';
import {BrowserRouter, Routes, Route} from "react-router-dom";
import data from "./SpaceApp/data.js";

const root = ReactDOM.createRoot(document.getElementById('root'));
export default function App(){
  return(
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navbar/>}>
          <Route index element={<LandingPage/>}/>
          <Route path='Destination' element={<Destination dest={data.destinations}/>} />
          <Route path='Crew' element={<Crew crew={data.crew}/>}/>
          <Route path='Technology' element={<Technology tech={data.technology}/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

root.render(
  <React.StrictMode>
    <App data={data}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
